import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const QuotesBlotterRouteLazy = lazyWithRetry(() => import('./quotes-blotter-route'));
export function QuotesBlotterRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <QuotesBlotterRouteLazy />
    </Suspense>
  );
}
